import React from 'react';
import LegalDocument from '../../Components/LegalDocument';

const TermsOfUse = () => {
  return (
    <LegalDocument 
      documentType="terms_of_use"
      cssPrefix="termsofuse"
    />
  );
};

export default TermsOfUse;